import React from "react"
import { useTranslation } from "react-i18next"

import "./ReviewsWidgetLittle.scss"

const ReviewsWidgetLittle = () => {
  const { t, i18n } = useTranslation()
  const YandexRating = 5.0
  const GoogleRating = 5.0
  const GoogleReviewsCount = 17
  const YANDEX_REVIEWS_LINK = process.env.GATSBY_YANDEX_REVIEWS_LINK
  const GOOGLE_REVIEWS_LINK = process.env.GATSBY_GOOGLE_REVIEWS_LINK

  const generateStars = rating => {
    return [...Array(5)].map((_, index) => {
      const fillPercentage = Math.min(Math.max(rating - index, 0), 1) * 100

      return (
        <svg
          key={index}
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 512 512"
          className="widget-star"
        >
          <defs>
            <linearGradient id={`starGradient-${index}`}>
              <stop offset={`${fillPercentage}%`} stopColor="#f0d355" />
              <stop offset={`${fillPercentage}%`} stopColor="#636052" />
            </linearGradient>
          </defs>
          <path
            fill={`url(#starGradient-${index})`}
            d="M395.39 494.627c-3.437 0-6.886-.798-10.061-2.418L256 426.233l-129.33 65.976a22.143 22.143 0 0 1-31.95-23.088l22.248-144.787L14.681 220.43a22.143 22.143 0 0 1 12.213-37.388L170 159.688l66.266-130.213a22.141 22.141 0 0 1 39.468 0L342 159.688l143.106 23.354a22.14 22.14 0 0 1 12.213 37.388L395.031 324.334l22.248 144.787a22.143 22.143 0 0 1-21.889 25.506z"
          />
        </svg>
      )
    })
  }

  return (
    <div className="widget-box">
      <div className="widget-box-top">
        {i18n.language === "en" ? (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            className="widget-google-icon"
            data-src="https://static.elfsight.com/icons/app-all-in-one-reviews-icons-google-multicolor.svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
          >
            <path
              fill="#2A84FC"
              d="M21.579 12.234c0-.677-.055-1.359-.172-2.025h-9.403v3.839h5.384a4.615 4.615 0 0 1-1.992 3.029v2.49h3.212c1.886-1.736 2.97-4.3 2.97-7.333Z"
            ></path>
            <path
              fill="#00AC47"
              d="M12.004 21.974c2.688 0 4.956-.882 6.608-2.406l-3.213-2.491c-.893.608-2.047.952-3.392.952-2.6 0-4.806-1.754-5.597-4.113H3.095v2.567a9.97 9.97 0 0 0 8.909 5.491Z"
            ></path>
            <path
              fill="#FFBA00"
              d="M6.407 13.916a5.971 5.971 0 0 1 0-3.817V7.531H3.095a9.977 9.977 0 0 0 0 8.953l3.312-2.568Z"
            ></path>
            <path
              fill="#FC2C25"
              d="M12.004 5.982a5.417 5.417 0 0 1 3.824 1.494l2.846-2.846a9.581 9.581 0 0 0-6.67-2.593A9.967 9.967 0 0 0 3.095 7.53l3.312 2.57c.787-2.363 2.996-4.117 5.597-4.117Z"
            ></path>
          </svg>
        ) : (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            fill="none"
            className="widget-google-icon"
          >
            <path
              d="M2.04 12c0-5.523 4.476-10 10-10 5.522 0 10 4.477 10 10s-4.478 10-10 10c-5.524 0-10-4.477-10-10z"
              fill="#FC3F1D"
            />
            <path
              d="M13.32 7.666h-.924c-1.694 0-2.585.858-2.585 2.123 0 1.43.616 2.1 1.881 2.959l1.045.704-3.003 4.487H7.49l2.695-4.014c-1.55-1.111-2.42-2.19-2.42-4.015 0-2.288 1.595-3.85 4.62-3.85h3.003v11.868H13.32V7.666z"
              fill="#fff"
            />
            <script xmlns="" />
          </svg>
        )}
        <p className="widget-rating">
          {i18n.language === "en" ? GoogleRating : YandexRating}
        </p>
        {generateStars(i18n.language === "en" ? GoogleRating : YandexRating)}
      </div>

      <div className="widget-box-bottom">
        <a
          href={
            i18n.language === "en" ? GOOGLE_REVIEWS_LINK : YANDEX_REVIEWS_LINK
          }
          className="widget-link"
          target="_blank"
        >
          {t(`Read our {{count}} reviews`, { count: GoogleReviewsCount })}
        </a>
      </div>
    </div>
  )
}

export default ReviewsWidgetLittle
